import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Archive from './pages/Archive';
import WritePost from './pages/WritePost';
import PostDetail from './pages/PostDetail';
import ProfilePage from './pages/About';
import Auth from './pages/Auth';
import NotFound from './pages/NotFound';
import { useUser } from './utils/userContext';

function App() {
  const { user } = useUser();

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route path="/archive" element={<Archive />} />
        <Route path="/write" 
          element={user ? <WritePost /> : <Navigate to="/login" replace />} 
        />
        <Route path="/article/:id" element={<PostDetail />} />
        <Route path="/about" element={<ProfilePage />} />
        <Route path="/login" element={<Auth />} />
        <Route path="/register" element={<Auth />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;